import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { DataView } from "primereact/dataview";
import { getUserData } from "../../utils/localStorage";
import { formatDate, formatDateNewWithTime, maskMobileNumber } from "../../constants/DateUtil/DateUtil";
import { Accordion, AccordionTab } from "primereact/accordion";
import { DeliveryReturnRequest } from "../../services/StoreCustomerDeliveryRequest/updatePickupRequest";
import {
  updateDeliveryRequest,
  updatePickupRequest,
} from "../../services/StoreRiderInfo/StoreRiderInfo";
import SuccessModal from "../SuccessModal";
import PickupRequest from "../PickupAndDeliveryModal/PickupRequest";
import DeliveryRequest from "../PickupAndDeliveryModal/DeliveryRequest";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
const { innerWidth: width, innerHeight: height } = window;


const JobRequestsListView = ({ orderInfoData, JobType, storeId, callRequestApi, pickupType }) => {
  const { userProfileRole } = getUserData();

  const userRole = userProfileRole;

  const [selectedItem, setSelectedItem] = useState(orderInfoData[0]?.id);
  const [selectedItemForEdit, setSelectedItemForEdit] = useState(null);
  const [pickupRequestModalVisible, setPickupRequestModalVisible] =
    useState(false);
  const [deliveryRequestModalVisible, setDeliveryRequestModalVisible] =
    useState(false);
  const [selectedRiderDetails, setSelectedRiderDetails] = useState(null);
  const [pickupDeliveryRequestData, setPickupDeliveryRequestData] =
    useState(null);

  const [modalVisible, setModalVisible] = useState(false);
  const [apiResStatus, setApiResStatus] = useState(null);
  const [apiResMessage, setApiResMessage] = useState("");

  const handleItemPress = (item) => {
    setSelectedItem((prevSelectedItem) =>
      prevSelectedItem === item.id ? null : item.id
    );
    setSelectedItemForEdit(item.id);
    // Set the selected rider details when an item is pressed
    setSelectedRiderDetails(item.rider_details);
  };

  const onEdit = ({ pickupDeliveryRequestData }) => {
    if (JobType == "pickup") {
      setPickupRequestModalVisible(true);
    } else {
      setDeliveryRequestModalVisible(true);
    }
    setPickupDeliveryRequestData(pickupDeliveryRequestData);
    // Implement your edit functionality here using the itemId
    // You can navigate to an edit screen or perform any other action here.
  };

  const navigate = useNavigate();

  const [collectPaymentResponse, setCollectPaymentResponse] = useState(null);
  const receiveResponse = ({ message, status, modalFun }) => {
    setApiResStatus(status);
    setApiResMessage(message);
    setCollectPaymentResponse(modalFun);
  };
  useEffect(() => {
    if (collectPaymentResponse !== null) {
      callRequestApi();
      setModalVisible(true);
      setCollectPaymentResponse(null);
    }
  }, [collectPaymentResponse]);

  const handlePickupCancelRequest = (item) => {
    const storeCustomerId = item?.storeCustomerId;
    const updatedPickupRequest = {
      id: item.id,
      storeId: storeId,
      storeCustomerId: storeCustomerId,
      pickupTimeSlot: item.pickupDeliveryTimeSlot,
      pickupOn: item.pickupDeliveryOn,
      pickupStatus:
        userRole === "BY_RIDER" ? "CANCEL_BY_RIDER" : "CANCEL_BY_STORE",
      remarks: "",
    };
    // Call the service function for updating pickup request
    updatePickupRequest(storeCustomerId, storeId, updatedPickupRequest)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          if (Res) {
            const message = Res.message;
            const status = Res.status;
            receiveResponse({
              message,
              status,
              modalFun: false,
            });
          }
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const handleDeliveryCancelRequest = (item) => {
    const storeCustomerId = item.deliveryRequest.order.storeCustomerId;
    // Logic for updating a pickup request
    const updatedDeliveryRequest = {
      id: item.id,
      storeId: storeId,
      storeCustomerId: storeCustomerId,
      order: {
        id: item.orderId,
      },
      deliveryTimeSlot: item.pickupDeliveryTimeSlot,
      deliveryOn: item.pickupDeliveryOn,
      deliveryStatus:
        userRole === "BY_RIDER" ? "CANCEL_BY_RIDER" : "CANCEL_BY_STORE",
      remarks: "",
    };

    // Call the service function for updating pickup request
    updateDeliveryRequest(storeCustomerId, storeId, updatedDeliveryRequest)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          if (Res) {
            const message = Res.message;
            const status = Res.status;
            receiveResponse({ message, status, modalFun: false });
          }
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const handleDeliveryReturnRequest = (item) => {
    // Logic for updating a pickup request
    const updatedDeliveryRequest = {
      id: item.id,
      storeId: storeId,
      order: {
        id: item.orderId,
      },
      deliveryTimeSlot: item.pickupDeliveryTimeSlot,
      deliveryOn: item.pickupDeliveryOn,
      deliveryStatus: "RESCHEDULE_BY_RIDER",
      remarks: "",
    };

    // Call the service function for updating pickup request
    DeliveryReturnRequest(storeId, updatedDeliveryRequest)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          if (Res) {
            const message = Res.message;
            const status = Res.status;
            receiveResponse({ message, status, modalFun: false });
          }
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  // const handlePhoneCall = (mobile) => {
  //   if (!mobile) {
  //     return alert("Mobile number is invalid");
  //   }
  //   const url = `tel:+91 ${mobile}`;

  //   // Linking.openURL(url)
  //   //   .then(() => alert('Phone Dial Opened successfully'))
  //   //   .catch(() => alert('Make sure Mobile Number is valid'));
  // };

  const handleLocation = (currentLocation, latitude, longitude) => {
    let url = "";
    if (currentLocation) {
      url = currentLocation;
    } else {
      url = `https://maps.google.com?q=${latitude},${longitude}`;
    }
    window.open(url);
  };

  const RenderTabView = () => {
    if (!orderInfoData || orderInfoData.length === 0) return null;

    const tableData = orderInfoData.map((item) => {
      if (JobType === "pickup") {
        return {
          id: item.pickupRequest.id,
          storeUserId: item.storeUserId,
          formattedPickupDeliveryDate: formatDate(item.pickupRequest.pickupOn),
          formattedPickupDeliveryCompleteOnDate: formatDate(item.pickupRequest.lastModifiedDate),
          pickupDeliveryOn: item.pickupRequest.pickupOn,
          customerName: item.pickupRequest.customerName,
          customerMobile: item.pickupRequest.customerMobile,
          customerAddress: item.pickupRequest.customerAddress,
          pickupDeliveryTimeSlot: item.pickupRequest.pickupTimeSlot,
          riderFirstName: item.pickupRequest.rider.firstName,
          riderLastName: item.pickupRequest.rider.lastName,
          pickupDeliveryStatus: item.pickupRequest.pickupStatus,
          pickupDeliveryOrderStatus: "",
          pickupDeliveryRequestId: item.pickupRequest.id,
          storeCustomerId: item.pickupRequest.storeCustomerId,
          source: item.pickupRequest.source,
          customerType: item.pickupRequest.customerType,
          orderId: null,
          orderNo: null,
          invoiceNo: item?.pickupRequest?.order?.invoiceNo || 'N/A',
          createdDate: formatDate(item.createdDate),
          createdDateWithTime: formatDateNewWithTime(item.createdDate),
          currentLocation: item.pickupRequest.addressDTO.currentLocation,
          latitude: item.pickupRequest.addressDTO.latitude,
          longitude: item.pickupRequest.addressDTO.longitude,
          remarks: item.pickupRequest.remarks,
        };
      } else {
        return {
          id: item.deliveryRequest.id,
          storeUserId: item.storeUserId,
          formattedPickupDeliveryDate: formatDate(item.deliveryRequest.deliveryOn),
          formattedPickupDeliveryCompleteOnDate: formatDate(item.deliveryRequest.lastModifiedDate),
          pickupDeliveryOn: item.deliveryRequest.deliveryOn,
          customerName: item.deliveryRequest.order.customerName,
          customerMobile: item.deliveryRequest.order.customerMobile,
          customerAddress: item.deliveryRequest.order.customerAddress,
          pickupDeliveryTimeSlot: item.deliveryRequest.deliveryTimeSlot,
          riderFirstName: item.deliveryRequest.rider.firstName,
          riderLastName: item.deliveryRequest.rider.lastName,
          pickupDeliveryStatus: item.deliveryRequest.deliveryStatus,
          pickupDeliveryOrderStatus: item.deliveryRequest.order.status,
          pickupDeliveryRequestId: item.deliveryRequest.id,
          storeCustomerId: item.deliveryRequest.order.storeCustomerId,
          orderId: item.deliveryRequest.order.id,
          orderNo: item.deliveryRequest.order.orderNo,
          invoiceNo: item.deliveryRequest.order.invoiceNo,
          createdDate: formatDate(item.createdDate),
          createdDateWithTime: formatDateNewWithTime(item.createdDate),
          currentLocation: item.deliveryRequest.addressDTO.currentLocation,
          latitude: item.deliveryRequest.addressDTO.latitude,
          longitude: item.deliveryRequest.addressDTO.longitude,
          remarks: item.deliveryRequest.remarks,
        };
      }
    });

    const BodyTemplate = (rowData) => {
      return (
        <div className="flex gap-0">

          <div
            style={{
              backgroundColor: "#008000",
              borderWidth: 1,
              borderColor: "#008000",
              width: 25,
              height: 25,
              borderRadius: 5,
            }}
            className="flex justify-content-center align-items-center ml-1 mr-2 my-1 cursor-pointer"
          >
            <a href={`tel:${ maskMobileNumber(rowData?.customerMobile)}`}>
              <i
                className="pi pi-phone"
                style={{
                  fontSize: "16px",
                  color: "#fff",
                }}
              ></i>
            </a>
          </div>

          {userRole === "BY_STORE" &&
            rowData?.pickupDeliveryStatus !== "OUT_FOR_DELIVERY" && (
              <div>
                <div
                  className="flex justify-content-center align-items-center mx-1 my-1 cursor-pointer"
                  onClick={() =>
                    onEdit({
                      pickupDeliveryRequestData: {
                        id: rowData?.pickupDeliveryRequestId,
                        storeCustomerId: rowData?.storeCustomerId,
                        storeUserId: rowData?.storeUserId,
                        pickupDeliveryTimeSlot: rowData?.pickupDeliveryTimeSlot,
                        pickupOn: rowData?.pickupDeliveryOn,
                        riderName:
                          rowData?.riderFirstName + rowData?.riderLastName,
                        orderId: rowData?.orderId,
                        pickupDeliveryStatus:
                          rowData?.pickupDeliveryStatus,
                        orderNo: rowData?.orderNo,
                        invoiceNo: rowData?.invoiceNo,
                        createdDate: rowData?.createdDate,
                      },
                    })
                  }
                >
                  <i
                    className="pi pi-pencil"
                    style={{
                      fontSize: "22px",
                      color: "#008EFF",
                    }}
                  ></i>
                </div>
              </div>
            )}

          {JobType === "pickup" && (
            <>
              {userRole !== "BY_SUPPORT_ADMIN" && (
                <div className="cursor-pointer">
                  <div
                    onClick={() =>
                      navigate("/BookNewOrder", {
                        state: {
                          storeCustomerId: rowData?.storeCustomerId,
                        },
                      })
                    }
                  >
                    <img
                      src="Laundy_App_Icons_Gifs/Customer_Info_GIFs/Book_New_Order.gif"
                      style={{ width: 45, height: 35 }}
                    />
                  </div>
                </div>
              )}

              <div
                className="justify-content-center align-items-center mx-1 my-1 cursor-pointer"
                onClick={() => handlePickupCancelRequest(rowData)}
              >
                <div
                  className="py-1 px-2"
                  style={{ backgroundColor: "red", borderRadius: 5 }}
                >
                  <p className="text-sm text-white font-bold capitalize">
                    Cancel
                  </p>
                </div>
              </div>
            </>
          )}

          {JobType !== "pickup" &&
            rowData?.pickupDeliveryStatus === "ASSIGNED_TO_RIDER" && (
              <div
                className="justify-content-center align-items-center mx-1 my-1 cursor-pointer"
                onClick={() => handleDeliveryCancelRequest(rowData)}
              >
                <div
                  className="py-1 px-2"
                  style={{ backgroundColor: "red", borderRadius: 5 }}
                >
                  <p
                    style={{
                      fontWeight: "600",
                      fontSize: 15,
                      color: "#fff",
                    }}
                  >
                    Cancel
                  </p>
                </div>
              </div>
            )}

          {JobType !== "pickup" &&
            userRole === "BY_RIDER" &&
            rowData?.pickupDeliveryStatus === "OUT_FOR_DELIVERY" && (
              <div
                className="justify-content-center align-items-center mx-1 my-1 cursor-pointer"
                onClick={() => handleDeliveryReturnRequest(rowData)}
              >
                <div
                  className="py-1 px-2"
                  style={{ backgroundColor: "red", borderRadius: 5 }}
                >
                  <p
                    style={{
                      fontWeight: "600",
                      fontSize: 15,
                      color: "#fff",
                    }}
                  >
                    Return
                  </p>
                </div>
              </div>
            )}

          {(rowData?.currentLocation ||
            (rowData?.latitude && rowData?.longitude)) && (
              <div>
                <div
                  className="flex justify-content-center align-items-center mx-1 my-1 cursor-pointer"
                  onClick={() =>
                    handleLocation(
                      rowData?.currentLocation,
                      rowData?.latitude,
                      rowData?.longitude
                    )
                  }
                >
                  <i
                    className="pi pi-map-marker"
                    style={{
                      fontSize: "20px",
                      color: "red",
                    }}
                  ></i>
                </div>
              </div>
            )}
        </div>
      );
    };


    const BodyTemplateMobile = (rowData) => {
      return (
        <div  >

          <span >
            {maskMobileNumber(rowData?.customerMobile)}
          </span>

        </div>
      )
    }


    return (
      <DataTable
        value={tableData}
        paginator
        rows={10}
        tableStyle={{ minWidth: '120rem' }}
        rowsPerPageOptions={[10, 25, 50]}
        stripedRows
        showGridlines
        responsiveLayout="scroll"
        scrollable
        scrollHeight={height - 150}
      >

        <Column
          header="S No."
          style={{ width: "70px" }}
          body={(rowData, options) =>
            options.rowIndex + 1}
        ></Column>
        {pickupType !== "ORDER_BOOKED" && pickupType !== "ORDER_CANCEL" && (
          <Column
            field="edit"
            style={{
              width: "90px",
              paddingVertical: 1,
              paddingLeft: 5,
              paddingRight: 1,
            }}
            header="Action"
            body={BodyTemplate}
          />
        )}

        {(pickupType === "ORDER_BOOKED") && (
          <Column field="invoiceNo" style={{
            width: "90px",
            paddingVertical: 1,
            paddingLeft: 5,
            paddingRight: 1,
          }} header="Invoice No" />
        )}

        {JobType === "delivery" && (
          <Column field="invoiceNo" style={{
            width: "90px",
            paddingVertical: 1,
            paddingLeft: 5,
            paddingRight: 1,
          }} header="Invoice No" />
        )}
        {pickupType === "ORDER_BOOKED" && (<Column field="formattedPickupDeliveryCompleteOnDate" style={{
          width: "90px",
          paddingVertical: 1,
          paddingLeft: 5,
          paddingRight: 1,
        }} header="Done On" />)}
        <Column field="createdDateWithTime" style={{
          width: "110px",
          paddingVertical: 1,
          paddingLeft: 5,
          paddingRight: 1,
        }} header="Created At" />
        <Column field="rider" header="Rider" style={{
          width: "90px",
          paddingVertical: 1,
          paddingLeft: 5,
          paddingRight: 1,
        }} body={(rowData) => rowData?.riderFirstName + " " + rowData?.riderLastName} />
        <Column field="customerName" style={{
          width: "90px",
          paddingVertical: 1,
          paddingLeft: 5,
          paddingRight: 1,
        }} header="Customer" />
        <Column field="customerMobile" style={{
          width: "90px",
          paddingVertical: 1,
          paddingLeft: 5,
          paddingRight: 1,
        }} header="Mobile" body={BodyTemplateMobile} />
        <Column field="customerAddress" style={{
          width: "140px",
          paddingVertical: 1,
          paddingLeft: 5,
          paddingRight: 1,
        }} header="Address" />

        <Column field="formattedPickupDeliveryDate" style={{
          width: "120px",
          paddingVertical: 1,
          paddingLeft: 5,
          paddingRight: 1,
        }} header="Reschedule Date" />
        <Column field="pickupDeliveryTimeSlot" style={{
          width: "90px",
          paddingVertical: 1,
          paddingLeft: 5,
          paddingRight: 1,
        }} header="Time Slot" />

        <Column field="status" header="Status" style={{
          width: "110px",
          paddingVertical: 1,
          paddingLeft: 5,
          paddingRight: 1,
        }} body={(rowData) => rowData?.pickupDeliveryStatus.replace(/_/g, " ")} />

        {JobType === "pickup" && (<Column field="source" style={{
          width: "110px",
          paddingVertical: 1,
          paddingLeft: 5,
          paddingRight: 1,
        }} header="Source" />
        )}
        {JobType === "pickup" && (<Column field="customerType" style={{
          width: "110px",
          paddingVertical: 1,
          paddingLeft: 5,
          paddingRight: 1,
        }} header="Customer Type" />
        )}
        <Column field="remarks" style={{
          width: "150px",
          paddingVertical: 1,
          paddingLeft: 5,
          paddingRight: 1,
        }} header="Remarks" />
      </DataTable>
    );
  };

  return (
    <div className="mx-4 my-2">
      <div className="mx-4 report-table">
        <div className="tab-view-table">{RenderTabView()}</div>
      </div>

      {pickupRequestModalVisible && (
        <PickupRequest
          setPickupRequestModalVisible={setPickupRequestModalVisible}
          pickupRequestModalVisible={pickupRequestModalVisible}
          status={"success"}
          text={"Your order is placed successfully."}
          storeId={storeId}
          editMode={true}
          sendResponse={receiveResponse}
          pickupDeliveryRequestData={pickupDeliveryRequestData}
        />
      )}
      {deliveryRequestModalVisible && (
        <DeliveryRequest
          setDeliveryRequestModalVisible={setDeliveryRequestModalVisible}
          deliveryRequestModalVisible={deliveryRequestModalVisible}
          status={"success"}
          text={"Your order is placed successfully."}
          storeId={storeId}
          editMode={true}
          sendResponse={receiveResponse}
          pickupDeliveryRequestData={pickupDeliveryRequestData}
        />
      )}
      <SuccessModal
        setModalVisible={setModalVisible}
        modalVisible={modalVisible}
        status={apiResStatus === true ? "success" : false}
        text={apiResMessage}
      />
    </div>
  );
};

export default JobRequestsListView;
